import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import * as React from 'react';

import { useChatState } from '../../store';

export const DrawerBody: React.FC = ({ children }) => {
	const { breakpoint } = useChatState();
	const drawerBodyInnerRef = React.useRef<HTMLDivElement>(null);

	React.useEffect(() => {
		if (breakpoint === 'mobile') {
			if (drawerBodyInnerRef.current) {
				disableBodyScroll(drawerBodyInnerRef.current, {
					reserveScrollBarGap: true,
				});
			}
		} else {
			clearAllBodyScrollLocks();
		}

		return () => {
			clearAllBodyScrollLocks();
		};
	}, [breakpoint]);

	return (
		<div data-testid="chatbot-drawer-body" className="c-chatbot-drawer__body">
			<div
				ref={drawerBodyInnerRef}
				className="c-chatbot-drawer__body-inner text-body-sm w-full p-4"
			>
				{children}
			</div>
		</div>
	);
};

export default DrawerBody;
